import { memo } from '@morphic-ts/common/es6/utils';
import { getEq as EgetEq } from 'fp-ts/Either';
import { eq, eqBoolean, eqNumber, eqStrict, eqString } from 'fp-ts/Eq';
import { getEq as OgetEq } from 'fp-ts/Option';
import { pipe } from 'fp-ts/pipeable';
import { getEq as AgetEq } from 'fp-ts/ReadonlyArray';
import { getEq as NEAgetEq } from 'fp-ts/ReadonlyNonEmptyArray';
import { eqApplyConfig } from '../config';
import { EqType, EqURI } from '../hkt';
const getOptionalEq = (eq) => ({
    equals: (a, b) => (a === undefined ? b === undefined : b !== undefined && eq.equals(a, b))
});
/**
 *  @since 0.0.1
 */
export const eqPrimitiveInterpreter = memo(() => ({
    _F: EqURI,
    date: config => env => new EqType(eqApplyConfig(config)(eq.contramap(eqNumber, (date) => date.getTime()), env, {})),
    boolean: config => env => new EqType(eqApplyConfig(config)(eqBoolean, env, {})),
    string: config => env => new EqType(eqApplyConfig(config)(eqString, env, {})),
    number: config => env => new EqType(eqApplyConfig(config)(eqNumber, env, {})),
    bigint: config => env => new EqType(eqApplyConfig(config)(eqStrict, env, {})),
    stringLiteral: (k, config) => env => new EqType(eqApplyConfig(config)(eqString, env, {})),
    numberLiteral: (k, config) => env => new EqType(eqApplyConfig(config)(eqNumber, env, {})),
    oneOfLiterals: (k, config) => env => new EqType(eqApplyConfig(config)(eqStrict, env, {})),
    tag: (k, config) => env => new EqType(eqApplyConfig(config)(eqString, env, {})),
    keysOf: (keys, config) => env => new EqType(eqApplyConfig(config)(eqStrict, env, {})),
    nullable: (getType, config) => env => pipe(getType(env).eq, eq => new EqType(eqApplyConfig(config)(OgetEq(eq), env, { eq }))),
    optional: (getType, config) => env => pipe(getType(env).eq, eq => new EqType(eqApplyConfig(config)(getOptionalEq(eq), env, { eq }))),
    mutable: (getType, config) => env => pipe(getType(env).eq, eq => new EqType(eqApplyConfig(config)(eq, env, { eq }))),
    array: (getType, config) => env => pipe(getType(env).eq, eq => new EqType(eqApplyConfig(config)(AgetEq(eq), env, { eq }))),
    nonEmptyArray: (getType, config) => env => pipe(getType(env).eq, eq => new EqType(eqApplyConfig(config)(NEAgetEq(eq), env, { eq }))),
    uuid: config => env => new EqType(eqApplyConfig(config)(eqString, env, {})),
    either: (e, a, config) => env => ((left, right) => new EqType(eqApplyConfig(config)(EgetEq(left, right), env, { left, right })))(e(env).eq, a(env).eq),
    option: (a, config) => env => pipe(a(env).eq, eq => new EqType(eqApplyConfig(config)(OgetEq(eq), env, { eq }))),
    unknownE: (a, config) => env => new EqType(eqApplyConfig(config)(a(env).eq, env, {}))
}));
